import React, { useRef } from 'react';
import { gsap, useGSAP } from '../lib/gsap';

// Self-contained metric card that counts up from 0 to `value` when scrolled
// into view. Number is GSAP-controlled; value/decimals are language-independent
// so a language toggle never fights the animation.
const StatCounter = ({ value, decimals = 0, prefix = '', suffix = '', label, icon }) => {
    const ref = useRef(null);
    const numRef = useRef(null);

    useGSAP(() => {
        const fmt = (n) => `${prefix}${Number(n).toFixed(decimals)}${suffix}`;
        if (numRef.current) numRef.current.textContent = fmt(0);

        const mm = gsap.matchMedia();
        const target = { v: 0 };

        mm.add('(prefers-reduced-motion: no-preference)', () => {
            gsap.to(target, {
                v: value,
                duration: 1.4,
                ease: 'power1.out',
                scrollTrigger: { trigger: ref.current, start: 'top 85%', once: true },
                onUpdate: () => {
                    if (numRef.current) numRef.current.textContent = fmt(target.v);
                },
            });
        });

        mm.add('(prefers-reduced-motion: reduce)', () => {
            if (numRef.current) numRef.current.textContent = fmt(value);
        });

        return () => mm.revert();
    }, { scope: ref });

    return (
        <div
            ref={ref}
            className="reveal-card bg-white dark:bg-gray-800 rounded-xl shadow-lg p-6 text-center"
        >
            {icon && (
                <div className="text-blue-500 dark:text-blue-400 text-2xl mb-3">
                    <i className={icon}></i>
                </div>
            )}
            <div ref={numRef} className="text-4xl font-bold text-gradient mb-2">
                {`${prefix}${Number(value).toFixed(decimals)}${suffix}`}
            </div>
            <p className="text-sm text-gray-600 dark:text-gray-400">{label}</p>
        </div>
    );
};

export default StatCounter;
